import React from 'react';
import DocumentMeta from 'react-document-meta';

class PrivacyPolicy extends React.Component {
	render() {
		const meta = {
			title: 'Privatlivspolitik – Alaska Cykler',
			description: 'Læs om hvordan Alaska Cykler indsamler, bruger og beskytter dine personoplysninger.',
			canonical: window.location.href,
			meta: {
				charset: 'utf-8',
				name: {
					keywords: 'alaska cykler privatlivspolitik, persondata, gdpr, cookies, rettigheder'
				}
			}
		};

		return (
			<div className="main-content" id="policy-page">
				<DocumentMeta {...meta} />

				<div className="container policy-container">
					<header className="header header-main text-left row">
						<h2 className="col-md-12 text-left">
							Privatlivspolitik
							<p>Privatlivspolitik – Alaska Cykler</p>
						</h2>
					</header>

					<div className="row">
						<div className="col-md-10">
							<p className="policy-meta"><strong>Senest opdateret:</strong> 22. oktober 2026</p>

							<p>
								Hos Alaska Cykler respekterer vi dit privatliv og passer godt på dine personoplysninger. Her kan du læse, hvilke oplysninger vi indsamler, hvorfor vi bruger dem, og hvordan vi beskytter dem.
							</p>

							<h3 className="sec-head">1. Hvem er vi?</h3>
							<p>
								Alaska Cykler er ansvarlig for behandlingen af dine personoplysninger.
							</p>
							<p>
								<strong>Virksomhedsoplysninger:</strong>
							</p>
							<ul>
								<li>Virksomhed: Alaska Cykler</li>
								<li>CVR-nr.: 38971069</li>
								<li>Telefon: <a href="tel:+4571873167">71 87 31 67</a></li>
								<li>E-mail: <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a></li>
							</ul>
							<p>
								Hvis du har spørgsmål til vores behandling af dine personoplysninger, er du altid velkommen til at kontakte os.
							</p>

							<h3 className="sec-head">2. Hvilke oplysninger indsamler vi?</h3>
							<p>
								Vi indsamler kun de oplysninger, der er nødvendige for at hjælpe dig som kunde.
							</p>
							<p>
								Det kan for eksempel være:
							</p>
							<ul>
								<li>Dit navn, telefonnummer og din e-mailadresse</li>
								<li>Din adresse, hvis den er nødvendig i forbindelse med et køb eller en levering</li>
								<li>Oplysninger om dine køb, betalinger og bestillinger</li>
								<li>Oplysninger om cykelservice og reparationer</li>
								<li>Beskeder og oplysninger, du sender til os via e-mail eller kontaktformular</li>
								<li>Tekniske oplysninger om dit besøg på vores hjemmeside, hvis det er relevant</li>
							</ul>
							<p>
								Vi beder ikke om flere personoplysninger, end vi har brug for.
							</p>

							<h3 className="sec-head">3. Hvad bruger vi dine oplysninger til?</h3>
							<p>
								Vi bruger dine oplysninger til at give dig en god og tryg kundeoplevelse.
							</p>
							<p>
								Det betyder blandt andet, at vi bruger oplysningerne til at:
							</p>
							<ul>
								<li>Besvare dine spørgsmål og henvendelser</li>
								<li>Behandle dine køb og bestillinger</li>
								<li>Udføre cykelservice og reparationer</li>
								<li>Kontakte dig om din cykel eller din bestilling</li>
								<li>Behandle reklamationer og andre kundesager</li>
								<li>Håndtere fakturaer og betalinger</li>
								<li>Overholde de regler, der gælder for vores virksomhed</li>
								<li>Sikre, at vores hjemmeside fungerer korrekt</li>
							</ul>
							<p>
								Vi bruger kun dine oplysninger til relevante formål og i overensstemmelse med gældende lovgivning.
							</p>

							<h3 className="sec-head">4. Hvorfor må vi behandle dine oplysninger?</h3>
							<p>
								Vi behandler dine personoplysninger, når der er et lovligt grundlag for det.
							</p>
							<p>
								Det kan for eksempel være, når:
							</p>
							<ul>
								<li>Vi skal opfylde en aftale med dig</li>
								<li>Vi skal overholde lovgivningen</li>
								<li>Vi har en legitim interesse i at drive og beskytte vores virksomhed</li>
								<li>Du har givet dit samtykke, når det er nødvendigt</li>
							</ul>
							<p>
								Hvis behandlingen kræver dit samtykke, bruger vi først dine oplysninger til det pågældende formål, når du har givet samtykke.
							</p>

							<h3 className="sec-head">5. Deler vi dine oplysninger med andre?</h3>
							<p>
								Vi sælger aldrig dine personoplysninger.
							</p>
							<p>
								I nogle tilfælde kan det være nødvendigt at dele relevante oplysninger med virksomheder, der hjælper os med at drive vores forretning. Det kan for eksempel være IT-leverandører, betalingsudbydere, leveringsvirksomheder eller vores bogholder.
							</p>
							<p>
								Vi deler kun de oplysninger, der er nødvendige, og sørger for, at det sker i overensstemmelse med gældende regler.
							</p>
							<p>
								Vi kan også videregive oplysninger til offentlige myndigheder, hvis vi er forpligtede til det efter loven.
							</p>

							<h3 className="sec-head">6. Hvor længe gemmer vi dine oplysninger?</h3>
							<p>
								Vi gemmer kun dine personoplysninger, så længe der er behov for dem.
							</p>
							<p>
								Hvor længe vi opbevarer oplysningerne, afhænger blandt andet af, hvorfor vi har indsamlet dem, og om vi er forpligtede til at gemme dem efter lovgivningen.
							</p>
							<p>
								For eksempel skal visse regnskabsoplysninger opbevares i den periode, som bogføringsloven kræver.
							</p>
							<p>
								Når vi ikke længere har brug for oplysningerne, sletter eller anonymiserer vi dem, medmindre vi har et lovligt grundlag for at gemme dem længere.
							</p>

							<h3 className="sec-head">7. Cookies på vores hjemmeside</h3>
							<p>
								Vores hjemmeside kan bruge cookies for at få hjemmesiden til at fungere korrekt og gøre den nemmere at bruge.
							</p>
							<p>
								Hvis vi bruger statistik- eller markedsføringscookies, der kræver samtykke, bliver de først aktiveret, når du har givet dit samtykke.
							</p>
							<p>
								Du kan ændre eller trække dit samtykke tilbage via hjemmesidens cookieindstillinger, hvis denne mulighed er tilgængelig.
							</p>
							<p>
								Du kan også ændre dine cookieindstillinger i din browser. Hvis du blokerer visse cookies, kan nogle funktioner på hjemmesiden muligvis ikke fungere som forventet.
							</p>
							<p>
								De konkrete cookies afhænger af de funktioner og værktøjer, der anvendes på hjemmesiden.
							</p>

							<h3 className="sec-head">8. Hvordan beskytter vi dine oplysninger?</h3>
							<p>
								Vi gør vores bedste for at beskytte dine personoplysninger mod tab, misbrug og uautoriseret adgang.
							</p>
							<p>
								Vi anvender passende sikkerhedsforanstaltninger og begrænser adgangen til personoplysninger, når det er relevant.
							</p>
							<p>
								Selvom vi arbejder for at beskytte dine oplysninger, kan ingen digital løsning garantere fuldstændig sikkerhed.
							</p>

							<h3 className="sec-head">9. Dine rettigheder</h3>
							<p>
								Du har en række rettigheder efter databeskyttelsesreglerne.
							</p>
							<p>
								Afhængigt af situationen har du blandt andet ret til at:
							</p>
							<ul>
								<li>Få at vide, hvilke personoplysninger vi har om dig</li>
								<li>Få rettet oplysninger, der er forkerte</li>
								<li>Få slettet dine oplysninger, når betingelserne for sletning er opfyldt</li>
								<li>Få begrænset behandlingen af dine oplysninger</li>
								<li>Gøre indsigelse mod visse former for behandling</li>
								<li>Få udleveret eller overført dine oplysninger, når reglerne om dataportabilitet gælder</li>
								<li>Trække dit samtykke tilbage, hvis behandlingen er baseret på samtykke</li>
							</ul>
							<p>
								Hvis du ønsker at gøre brug af dine rettigheder, kan du kontakte os på <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a> eller ringe til os på <a href="tel:+4571873167">71 87 31 67</a>.
							</p>
							<p>
								Vi behandler din anmodning efter de regler og frister, der gælder.
							</p>

							<h3 className="sec-head">10. Klage til Datatilsynet</h3>
							<p>
								Hvis du mener, at vi behandler dine personoplysninger i strid med reglerne, er du velkommen til først at kontakte os, så vi kan se på sagen.
							</p>
							<p>
								Du har også ret til at klage til Datatilsynet.
							</p>
							<p>
								Du kan finde information om dine rettigheder og klagemuligheder på Datatilsynets hjemmeside:
							</p>
							<p>
								<a href="https://www.datatilsynet.dk" target="_blank" rel="noopener noreferrer">https://www.datatilsynet.dk</a>
							</p>

							<h3 className="sec-head">11. Ændringer i privatlivspolitikken</h3>
							<p>
								Vi kan opdatere denne privatlivspolitik, hvis vores behandling af personoplysninger ændrer sig, eller hvis der kommer nye krav i lovgivningen.
							</p>
							<p>
								Den nyeste version vil altid være tilgængelig på vores hjemmeside.
							</p>

							<h3 className="sec-head">12. Kontakt os</h3>
							<p>
								Har du spørgsmål til denne privatlivspolitik eller til, hvordan vi behandler dine personoplysninger?
							</p>
							<p>
								Du er altid velkommen til at kontakte os.
							</p>
							<p>
								<strong>Alaska Cykler</strong><br />
								Telefon: <a href="tel:+4571873167">71 87 31 67</a><br />
								E-mail: <a href="mailto:alaskacykler@mail.com">alaskacykler@mail.com</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default PrivacyPolicy;




// WEBPACK FOOTER //
// ./src/Pages/PrivacyPolicy.js